"use client";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from "@/components/ui/dialog";
import { useSession } from "next-auth/react";
import { addReview } from "@/utils/action/data";
import { trimText } from "@/lib/trimText";
import Rating from "@/custom/Rating";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "@/components/ui/use-toast";

const AddReview = ({ product, userData }) => {
  const session = useSession();
  const [currentValue, setCurrentValue] = useState(0);
  const [hoverValue, setHoverValue] = useState(0);
  const [comment, setComment] = useState("");

  const handleReview = async (e) => {
    e.preventDefault();

    if (currentValue < 1) {
      return toast({
        title: "Please give a rating of at least 1",
      });
    }

    const reviewData = {
      rating: currentValue,
      comment: comment || "",
      userName: userData?.name,
      userId: userData?._id,
      userImage: userData?.image,
      productId: product?._id,
      product: product,
    };

    const data = await addReview(reviewData);

    if (data?.success) {
      toast({
        title: "Success",
        description: "Review Added. Please wait until verify",
      });
      setCurrentValue(0);
      setHoverValue(0);
      setComment("");
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline">Add Review</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="text-lg font-medium">
            Add Ratings and Reviews for {trimText(product?.title, 60)}
          </DialogTitle>
          <DialogDescription>
            You can add your ratings and reviews. After finishing, click submit.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleReview}>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <h1 className="text-base">Rating</h1>
              <Rating
                currentValue={currentValue}
                setCurrentValue={setCurrentValue}
                hoverValue={hoverValue}
                setHoverValue={setHoverValue}
              />
            </div>
            <div className="flex flex-col gap-1">
              <h1 className="text-base">Comment</h1>
              <Textarea
                name="comment"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="col-span-3"
              />
            </div>
          </div>
          <DialogClose asChild>
            <Button type="submit" className="mt-3">
              Submit
            </Button>
          </DialogClose>
        </form>
        <DialogFooter></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddReview;
